module.exports = __webpack_public_path__ + "static/media/about_pic_mess4.19b497bd.jpg";